export const NON_PERSISTENT_STATE = 'non-persistent-state';
